<template lang="jade">
  .container-fluid
    .row
      .col-md-12
        h2 Schedule
</template>
<script>
export default {
  components: {
  },
  data () {
    return {

    }
  },
  asyncData () {
  },
  computed: {
  },
  methods: {

  }, // close methods
  ready () {
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

</style>



// WEBPACK FOOTER //
// Schedule.vue?c5e4ac9c